import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CFormGroup, CLabel, CInput, CSelect, CCardTitle } from '@coreui/react';
import moment from 'moment-timezone';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { fetchRolloverTime, updateRolloverTime } from '../../services/BackendService';
import _t from 'counterpart';
import ButtonWithLoader from '../../components/ButtonWithLoader';
import { handleFormError } from '../../helpers';
import toast from 'react-hot-toast';

const RolloverTimeSettings = () => {
  const [time, setTime] = useState<string>('00:00');
  const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const rolloverTimeQuery = useQuery('rolloverTime', () => fetchRolloverTime());
  const queryClient = useQueryClient();

  useEffect(() => {
    if (rolloverTimeQuery.data) {
      const { rolloverTime, timeZone } = rolloverTimeQuery.data;
      setTime(rolloverTime);
      setTimezone(timeZone);
    }
  }, [rolloverTimeQuery.data]);

  const updateRolloverMutation = useMutation(() => updateRolloverTime(time, timezone), {
    onSuccess: async () => {
      toast.success(_t('rollover.successfully-updated'));
      await queryClient.invalidateQueries(['rolloverTime']);
    },
    onError: async (e: any) => {
      handleFormError(e);
    },
  });

  const invokeMutation = () => {
    updateRolloverMutation.mutate();
  };
  return (
    <CCard className="mt-4">
      <CCardHeader>
        <CCardTitle>{_t(`rollover.title`)}</CCardTitle>
      </CCardHeader>
      <CCardBody>
        <CFormGroup>
          <CLabel htmlFor="time">{_t(`rollover.time`)}</CLabel>
          <CInput type="time" id="time" value={time} onChange={(e) => setTime((e.target as HTMLInputElement).value)} />
        </CFormGroup>

        <CFormGroup>
          <CLabel htmlFor="timezone">{_t(`rollover.timezone`)}</CLabel>
          <CSelect id="timezone" value={timezone} onChange={(e) => setTimezone((e.target as HTMLInputElement).value)}>
            {moment.tz.names().map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </CSelect>
        </CFormGroup>

        <ButtonWithLoader
          isLoading={updateRolloverMutation.isLoading}
          onClick={invokeMutation}
          buttonColor="primary"
          spinnerColor="secondary"
          title={_t('action.save')}
          className="btn-md"
          showText={false}
        />
      </CCardBody>
    </CCard>
  );
};

export default RolloverTimeSettings;
